(function () {
  'use strict';

  const money = (cents) => {
    const fmt = (window.themeSettings && window.themeSettings.moneyFormat) || '£{{amount}}';
    const amount = (cents / 100).toFixed(2);
    const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(cents / 100).toString());
  };

  function toast(message) {
    const el = document.getElementById('ThemeToast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 3200);
  }

  /* ---------------- Cart ---------------- */
  const CartDrawer = {
    el: () => document.getElementById('CartDrawer'),
    open() {
      const d = this.el();
      if (!d) return;
      d.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
    close() {
      const d = this.el();
      if (!d) return;
      d.classList.remove('is-open');
      document.body.style.overflow = '';
    },
  };
  window.CartDrawer = CartDrawer;

  function updateCartCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach((n) => {
      n.textContent = count;
      n.hidden = count === 0;
    });
  }

  async function refreshCart(openDrawer) {
    try {
      const res = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fresh = doc.getElementById('CartDrawer');
      const current = document.getElementById('CartDrawer');
      if (fresh && current) {
        const wasOpen = current.classList.contains('is-open');
        current.innerHTML = fresh.innerHTML;
        if (wasOpen || openDrawer) CartDrawer.open();
      }
      const cart = await (await fetch(`${window.routes.cart_url}.js`)).json();
      updateCartCounts(cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (e) {
      console.error(e);
    }
  }
  window.refreshCart = refreshCart;

  async function addToCart(form) {
    const btn = form.querySelector('[data-add-button]');
    const original = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = '…';
    }
    try {
      const res = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const data = await res.json();
      if (!res.ok) {
        toast(data.description || data.message || window.cartStrings.error);
        return;
      }
      if (window.themeSettings.cartDrawerEnabled) {
        await refreshCart(true);
      } else {
        window.location = window.routes.cart_url;
      }
    } catch (e) {
      toast(window.cartStrings.error);
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.textContent = original;
      }
    }
  }

  async function changeLine(line, quantity) {
    const res = await fetch(`${window.routes.cart_change_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
    });
    if (!res.ok) toast(window.cartStrings.error);
    await refreshCart(false);
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    if (!window.themeSettings.cartDrawerEnabled && !form.dataset.ajax) return;
    e.preventDefault();
    addToCart(form);
  });

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && window.themeSettings.cartDrawerEnabled) {
      e.preventDefault();
      CartDrawer.open();
      refreshCart(true);
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      CartDrawer.close();
      return;
    }
    const remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.dataset.lineRemove, 0);
      return;
    }
    const step = e.target.closest('[data-line-step]');
    if (step) {
      e.preventDefault();
      changeLine(step.dataset.line, step.dataset.qty);
      return;
    }
    const qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn) {
      e.preventDefault();
      const input = qtyBtn.parentElement.querySelector('input');
      const next = Math.max(1, parseInt(input.value, 10) + Number(qtyBtn.dataset.qty));
      input.value = next;
      return;
    }
    const menuToggle = e.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      const nav = document.getElementById('MobileNav');
      if (nav) {
        const open = nav.classList.toggle('is-open');
        menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') CartDrawer.close();
  });

  /* ---------------- Variant selection ---------------- */
  class VariantPicker {
    constructor(root) {
      this.root = root;
      this.productHandle = root.dataset.handle;
      this.variants = JSON.parse(root.querySelector('[data-variant-json]').textContent);
      this.root.addEventListener('click', (e) => {
        const pill = e.target.closest('.pill');
        if (!pill) return;
        e.preventDefault();
        this.root
          .querySelectorAll(`.pill[data-option-index="${pill.dataset.optionIndex}"]`)
          .forEach((p) => p.setAttribute('aria-pressed', 'false'));
        pill.setAttribute('aria-pressed', 'true');
        this.update();
      });
      this.root.querySelectorAll('select[data-option-index]').forEach((sel) => {
        sel.addEventListener('change', () => this.update());
      });
      this.update(true);
    }

    selected() {
      const opts = [];
      this.root.querySelectorAll('[data-option-group]').forEach((group) => {
        const pressed = group.querySelector('.pill[aria-pressed="true"]');
        const select = group.querySelector('select');
        opts.push(pressed ? pressed.dataset.value : select ? select.value : null);
      });
      return opts;
    }

    update(initial) {
      const opts = this.selected();
      const variant = this.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      const priceEl = this.root.querySelector('[data-price]');
      const compareEl = this.root.querySelector('[data-compare-price]');
      const idInput = this.root.querySelector('[data-variant-id]');
      const btn = this.root.querySelector('[data-add-button]');
      const stock = this.root.querySelector('[data-inventory]');
      const unitEl = this.root.querySelector('[data-unit-price]');

      if (!variant) {
        if (btn) {
          btn.disabled = true;
          btn.textContent = btn.dataset.unavailable || 'Unavailable';
        }
        if (stock) stock.textContent = '';
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.innerHTML = `<s>${money(variant.compare_at_price)}</s>`;
          compareEl.hidden = false;
        } else {
          compareEl.innerHTML = '';
          compareEl.hidden = true;
        }
      }
      if (unitEl) unitEl.textContent = variant.unit_price_text || '';
      if (btn) {
        btn.disabled = !variant.available;
        btn.textContent = variant.available
          ? btn.dataset.addLabel || 'Add to bag'
          : btn.dataset.soldOut || 'Sold out';
      }
      if (stock) {
        if (!variant.available) {
          stock.textContent = stock.dataset.soldOut || '';
        } else if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= Number(stock.dataset.lowThreshold || 0)) {
          stock.textContent = (stock.dataset.lowText || '').replace('[count]', variant.inventory_quantity);
        } else {
          stock.textContent = stock.dataset.inStock || '';
        }
      }

      // Sync media
      if (variant.featured_media_id) {
        const media = this.root.closest('.product')?.querySelector(`[data-media-id="${variant.featured_media_id}"]`);
        if (media) media.click();
      }

      if (!initial && this.productHandle) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('variant:changed', { detail: variant }));
    }
  }

  /* ---------------- Gallery ---------------- */
  function initGallery(root) {
    const main = root.querySelector('[data-gallery-main]');
    root.querySelectorAll('[data-media-id]').forEach((btn) => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('[data-media-id]').forEach((b) => b.setAttribute('aria-current', 'false'));
        btn.setAttribute('aria-current', 'true');
        if (main && btn.dataset.src) {
          main.src = btn.dataset.src;
          main.alt = btn.dataset.alt || main.alt;
        }
      });
    });
  }

  /* ---------------- Sticky buy bar ---------------- */
  function initStickyBar() {
    const bar = document.getElementById('StickyBuyBar');
    const anchor = document.querySelector('[data-buy-anchor]');
    if (!bar || !anchor) return;
    const io = new IntersectionObserver(
      ([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting),
      { rootMargin: '0px 0px -60% 0px' }
    );
    io.observe(anchor);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-variant-picker]').forEach((el) => {
      if (!el._vp) el._vp = new VariantPicker(el);
    });
    (scope || document).querySelectorAll('[data-gallery]').forEach(initGallery);
    initStickyBar();
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.id && e.target.id.indexOf('cart-drawer') > -1) CartDrawer.open();
  });
})();
